/**
 * Root stack navigator
 */

import React from 'react';
import { Platform } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import type { RootStackParamList } from './types';
import {
  DashboardScreen,
  FlightInputScreen,
  DoseLogScreen,
  AlertsScreen,
  SettingsScreen,
  TipsScreen,
} from '../screens';

const Stack = createNativeStackNavigator<RootStackParamList>();

export function RootNavigator() {
  return (
    <Stack.Navigator
      initialRouteName="Dashboard"
      screenOptions={{
        contentStyle: Platform.OS === 'web'
          ? ({ flex: 1, minHeight: '100vh' } as any)
          : { flex: 1 },
      }}
    >
      <Stack.Screen
        name="Dashboard"
        component={DashboardScreen}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen name="FlightInput" component={FlightInputScreen} />
      <Stack.Screen name="DoseLog" component={DoseLogScreen} />
      <Stack.Screen name="Alerts" component={AlertsScreen} />
      <Stack.Screen name="Settings" component={SettingsScreen} />
      <Stack.Screen name="Tips" component={TipsScreen} />
    </Stack.Navigator>
  );
}
